export const ArrowDownIcon = (props) => {
  const { fill='#eee', width='17.664', height='10.908' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 17.664 10.908">
      <path id="icon-arrow-down-inactive" d="M2.076,0,0,2.076,6.742,8.832,0,15.589l2.076,2.076,8.832-8.832Z" transform="translate(17.664) rotate(90)" fill={fill}/>
    </svg>
  );
}

export const ArrowUpIcon = (props) => {
  const { fill='#eee', width='17.664', height='10.908' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 17.664 10.908">
      <path id="icon-arrow-top-inactive" d="M2.076,0,0,2.076,6.742,8.832,0,15.589l2.076,2.076,8.832-8.832Z" transform="translate(0 10.908) rotate(-90)" fill={fill}/>
    </svg>
  );
}


export const ArrowDownIconSmall = (props) => {
  const { fill='#727272' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10.133" height="10" viewBox="0 0 10.133 10">
      <g id="down" transform="translate(0 0.133)">
        <path id="Path_36" data-name="Path 36" d="M6.7,8.1,2,3.4,3.4,2,6.7,5.3,10,2l1.4,1.4Z" transform="translate(-2 0.2)" fill={fill}/>
        <rect id="Rectangle_1467" data-name="Rectangle 1467" width="10" height="10" transform="translate(0.133 -0.133)" fill="none"/>
      </g>
    </svg>
  );
}
